import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

export default function SuccessStep() {
  return (
    <div className="text-center space-y-8 animate-fadeIn">
      <div className="flex justify-center">
        <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center">
          <SafeIcon icon={FiIcons.FiCheck} className="text-green-500 text-4xl" />
        </div>
      </div>

      <div className="space-y-4">
        <h3 className="text-2xl font-semibold text-brand-deep">
          Your RepUpgrade setup is ready for review.
        </h3>
        <p className="text-gray-600 max-w-md mx-auto">
          Check your email for your login credentials! We've captured your preferences and our system is now staging your custom environment.
        </p>
      </div>

      <div className="bg-gray-50 border border-gray-100 rounded-xl p-6 text-left max-w-md mx-auto space-y-4">
        <h4 className="text-brand-signal font-medium flex items-center">
          <SafeIcon icon={FiIcons.FiZap} className="mr-2" /> Next Actions
        </h4>
        
        <div className="space-y-3">
          <div className="flex items-start">
            <div className="bg-white border border-gray-200 rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold mr-3 mt-0.5">
              1
            </div>
            <p className="text-sm text-gray-700">Verify your Google Business Profile details.</p>
          </div>
          <div className="flex items-start">
            <div className="bg-white border border-gray-200 rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold mr-3 mt-0.5">
              2
            </div>
            <p className="text-sm text-gray-700">Finalize your custom brand voice settings.</p>
          </div>
          <div className="flex items-start">
            <div className="bg-white border border-gray-200 rounded-full w-6 h-6 flex items-center justify-center text-xs font-bold mr-3 mt-0.5">
              3
            </div>
            <p className="text-sm text-gray-700">Book your onboarding session with Joseph below.</p>
          </div>
        </div>
      </div>

      <div className="space-y-4">
        <a 
          href="https://worldbuilder.digitalcowboy.io/book/digitalcowboy/repupgrade" 
          target="_blank" 
          rel="noopener noreferrer"
          className="btn-primary w-full max-w-md py-4 text-lg"
        >
          Book Your Strategy Call with Joe
        </a>
        <br />
        <a 
          href="https://authoritybuilder.digitalcowboy.io/" 
          className="text-brand-signal hover:underline text-sm font-medium"
        >
          Go to RepUpgrade Dashboard
        </a>
      </div>
    </div>
  );
}